import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);


export const constantRoutes = [
    {
        name: 'home',
        path: '/',
        component: () => import('./components/BmwForm'),
        hidden: true
    },
    { path: '*', redirect: '/' }
];

const createRouter = () =>
	new Router({
		scrollBehavior: () => ({ y: 0 }),
		mode: 'history',
		routes: constantRoutes
	});

const router = createRouter();

export default router;
